import { Typography } from '@mui/material'

export const PageError = () => (
  <Typography variant='h4' color='error'>
    Page crashed
  </Typography>
)
